var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('Navbar'),_c('v-main',[_c('router-view')],1),_c('Footer'),(_vm.isAboutDialog)?_c('AboutDialog',{on:{"close":function($event){_vm.isAboutDialog = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }